import React from "react";
import { X, Check } from "lucide-react";

// Slice E2 · Set-as-Go-To confirmation modal.
//
// Replaces the native window.confirm() with a shadcn-style modal matching
// uReserve's Navy / Coral palette. Fired from App.js after a batch element
// edit creates a new auto-scenario — the user decides whether to activate
// the new scenario or keep the previous Go-To in place.
export default function SetGoToScenarioModal({
  scenarioName,
  onKeep,        // called when user clicks "Keep current Go-To"
  onActivate,    // called when user clicks "Set as Go-To"
}) {
  return (
    <div
      className="fixed inset-0 z-[80] flex items-center justify-center"
      style={{ background: "rgba(15,42,68,0.55)" }}
      data-testid="goto-modal"
      onClick={onKeep}
    >
      <div
        className="bg-white border-2 border-navy shadow-2xl w-[440px] max-w-[95vw] rounded-[8px]"
        onClick={(e) => e.stopPropagation()}
      >
        <div
          className="flex items-center justify-between px-4 py-2.5 border-b-2"
          style={{ background: "var(--u-navy-wash)", borderBottomColor: "#EA6A47" }}
        >
          <div className="text-[12px] tracking-[0.14em] uppercase font-bold text-navy">
            Auto-Scenario Created
          </div>
          <button
            onClick={onKeep}
            className="text-slate hover:text-coral"
            data-testid="goto-modal-close"
          >
            <X size={14} />
          </button>
        </div>

        <div className="px-5 py-4 text-[12px] text-ink leading-relaxed">
          <p className="mb-3">
            An <span className="font-semibold text-navy">Element edit</span> scenario
            was created to capture your changes:
          </p>
          <div
            className="border border-rule bg-[#F5F8FB] px-3 py-2 mb-3 font-mono text-[11px] text-navy"
            data-testid="goto-modal-scenario-name"
          >
            {scenarioName || "Element edit — …"}
          </div>
          <p className="text-slate">
            Would you like to set it as your default <span className="font-semibold text-ink">Go-To</span> scenario now? The Dashboard will reflect the edited element values.
          </p>
        </div>

        <div
          className="flex items-center justify-end gap-2 px-4 py-3 border-t border-rule"
          style={{ background: "#FAFBFC" }}
        >
          <button
            onClick={onKeep}
            data-testid="goto-modal-keep"
            className="border border-rule bg-white hover:border-navy hover:text-navy px-3 py-1.5 text-[11px] font-semibold text-slate"
          >
            Keep current Go-To
          </button>
          <button
            onClick={onActivate}
            data-testid="goto-modal-activate"
            className="flex items-center gap-1.5 bg-navy text-white hover:bg-[#12406B] px-3 py-1.5 text-[11px] font-semibold"
          >
            <Check size={12} />
            Set as Go-To
          </button>
        </div>
      </div>
    </div>
  );
}
